import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=1cf6728c&scoped=true&"
import script from "./Listado.vue?vue&type=script&lang=js&"
export * from "./Listado.vue?vue&type=script&lang=js&"
import style0 from "./Listado.vue?vue&type=style&index=0&id=1cf6728c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf6728c",
  null
  
)

export default component.exports